// eslint-disable-next-line import/no-cycle
import { useRuntimeConfig } from '#imports';
import featureLib from '~/lib/features';
import type { Mode } from '~/lib/mode-setup';

export const useFeatures = () => {
  const config = useRuntimeConfig();

  const features = featureLib(config.public.mode as Mode);

  return {
    features,
    defaultFeatures: features.defaultFeatures,
  };
};
